/**
 * Created by Omar Ben Aboud on 14/07/2019.
 */

export class  AbstractWSOutputVO {
    listErrorMsgs: Array<any> = [];
    listInformationMsgs: Array<any> = [];
}
